import { ReactElement, useCallback, useEffect, useState } from "react";
import useApiState, { api } from "../../hooks/use-api-state";
import { IGetUserStatisticsResponse } from "../../messages/IGetUserStatisticsResponse";
import Loading from "../common/Loading";
import { IUserInfo } from "../../messages/IAppInfo";
import ErrorNotification from "../common/ErrorNotification";
import styles from "./CohortStatistics.module.css";
import CohortStatistics from "./CohortStatistics";

export default function DashboardStatistics(props: {
    userInfo: IUserInfo;
}): ReactElement {
    const [apiState, setApiState] = useApiState(false);
    const [userStatistics, setUserStatistics] = useState<IGetUserStatisticsResponse | null>(null);

    const getMessageItems = useCallback(async () => {
        if (!apiState.isLoading)
        {
            try {
                setUserStatistics(await api.getUserRewards(setApiState, props.userInfo.user_id));
            } catch (e) {
            }
        }
        else {
            //console.log("Already loading user statistics");
        }
    }, [setApiState, props.userInfo]);

    useEffect(() => {
        getMessageItems();
    }, [getMessageItems]);

    return <>
        <Loading isLoading={apiState.isLoading}>{!!apiState.errorMessage && !apiState.isUnauthenticated ? (
            <ErrorNotification errorMessage={apiState.errorMessage} />
        ) : (
            <>
                {userStatistics !== null && userStatistics.itemList.map((item) => {
                    return (
                        <div key={`${item.cohort_code}/${item.lmodule_code}`}>
                            { userStatistics.itemList.length > 1 && 
                                <h3 style={{marginBlockEnd:-5}}>{item.title}</h3>
                            }
                            <div className={`${styles.dashboard__charts}`}>
                                <CohortStatistics 
                                    userInfo={props.userInfo}
                                    item={item}
                                    cohortReward={userStatistics.cohortsRewards[item.cohort_code]} 
                                    showTitle={false} />
                            </div>
                        </div>
                    );
                })
                }
            </>
        )}
        </Loading>
    </>;
}
